module.exports = __webpack_public_path__ + "img/donante-idip.312e8899.jpeg";